import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import Avatar from 'react-avatar';
import Button from 'react-bootstrap/Button';

import { api } from '../../util/apiCaller';
import { hasManageBilling, hasManageUsers } from '../../util/roles';
import { revokeRequest } from '../../modules/Users/UsersActions';
import { logout, requestAccount } from '../../modules/Auth/AuthActions';
import ImageSize from '../ImageSize/ImageSize';

// Import Style
import './User.scss';
import logoutIcon from '../../assets/img/logout.svg';


class User extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);

    this.state = {
      popupVisible: false
    };
  }

  handleClick() {
    if (!this.state.popupVisible) {
      // attach/remove event handler
      document.addEventListener('click', this.handleOutsideClick, false);
    } else {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }

    this.setState(prevState => ({
      popupVisible: !prevState.popupVisible
    }));
  }

  handleOutsideClick(e) {
    // ignore clicks on the component itself
    if (this.node && this.node.contains(e.target)) {
      return;
    }

    this.handleClick();
  }

  onRequest = acc => {
    this.props.requestAccount(acc.accountId);
    this.setState({
      popupVisible: false
    });
  };

  revokeRequest = () => {
    this.props.revokeRequest();
  };

  handleChangeAccount = accId => {
    api(`/account/select/${accId}`).then(() => {
      global.window && window.location && window.location.replace('/');
    });
  };

  handleCreateAccount = () => {
    api(`/account/create`).then(() => {
      global.window && window.location && window.location.replace('/');
    });
  };

  renderCreateAccountButton = (enabled = true) => {
    const { user } = this.props;
    if (enabled && !user.hasOwnAccount) {
      return (
        <a
          href="javascript:void(0)"
          onClick={() => this.handleCreateAccount()}
          className='btn btn-sm btn-primary'
        >
          Create account
        </a>
      )
    }
  }

  logout = () => {
    let url;

    if (this.props.outside) {
      const p = this.props.plugin;
      const host = p.host || this.props.user.host;
      url = `login?app=${p.app}&boardId=${p.boardId}&host=${host}`;
    }

    this.props.logout(url);
  };

  render() {
    const { user } = this.props;
    const relatedAccount = user.relatedAccounts && user.relatedAccounts[0];

    return (
      <div
        className='user'
        ref={node => {
          this.node = node;
        }}
      >
        <div className='user_img' onClick={this.handleClick}>
          {user && user.profile && user.profile.profileImg ? (
            <ImageSize src={user.profile.profileImg} alt="" />
          ) : (
            <Avatar name={user && user.profile ? user.profile.name : ''} size={28} round="8px" maxInitials={2} />
          )}
        </div>
        
        <div className='dropdown_user' style={{ display: this.state.popupVisible ? 'flex' : 'none' }}>
          {!!user.managedBy && (
            <div className='notification'>
              This account is managed by <strong>{user.managedBy}</strong>
            </div>
          )}
          <div className='profile_content'>
            <div className='profile-info'>
              <div className={`profile_text ${!!user.host && 'three-rows'}`}>
                <h2>{user && user.profile ? user.profile.name : ''}</h2>
                <p>{user.email}</p>
                {!!user.host && <p>{user.host}</p>}
              </div>
              <div className='avatar_change'>
                {user && user.profile && user.profile.profileImg ? (
                  <ImageSize src={user.profile.profileImg} alt="" />
                ) : (
                  <Avatar name={user && user.profile ? user.profile.name : ''} size={54} round="4px" maxInitials={2} />
                )}
              </div>
            </div>
            {relatedAccount && !relatedAccount.invited && (
              <div className='account-info'>
                There is an existing corporate account under your domain,{' '}
                <Link onClick={() => this.onRequest(relatedAccount)}>request access here →</Link>
              </div>
            )}
            {!!user.requestedAccount && (
              <div className='account-info'>
                We’ve notified your account managers.
                <br />
                <Link onClick={() => this.revokeRequest()}>Revoke request here →</Link>
              </div>
            )}

            {!user.isPartner && (
              <div className="profile-buttons">
                {hasManageUsers(user) && (
                  <Link to="/users" className='btn btn-sm btn-secondary'>
                    Manage Users
                  </Link>
                )}
                {hasManageBilling(user) && (
                  <Link to="/billing" className='btn btn-sm btn-secondary'>
                    Manage Billing
                  </Link>
                )}
              </div>
            )}
            {user.isPartner && hasManageUsers(user) && (
              <div className='profile-buttons'>
                <Link to="/users" className='btn btn-sm btn-secondary'>
                  Manage Users
                </Link>
              </div>
            )}
          </div>

          {user.accounts &&
            user.accounts.map((u, i) => {
              return (
                <div key={i} className='profile-info' onClick={() => this.handleChangeAccount(u.accountId)}> 
                  <div className='profile_text'>
                    <h2>{u.name}</h2>
                    <p>{u.email}</p>
                  </div>
                  <div className='avatar_change'>              
                    {user && user.profile && user.profile.profileImg ? (
                      <img src={user.profile.profileImg} alt="" />
                    ) : (
                      <Avatar name={user && user.profile ? user.profile.name : ''} size={54} round="4px" maxInitials={2} />
                    )}
                  </div>
                  <a
                    href="javascript:void(0)"
                    onClick={() => this.handleChangeAccount(u.accountId)}
                    className='link'
                  ></a>

                </div>
              );
            })}
          {(!this.props.outside || !user.hasOwnAccount) && (
            <div className='profile_footer'>
              {!this.props.outside && (
                <Button onClick={this.logout} variant="primary-link" size="md">
                  Sign out <img src={logoutIcon} alt="" />
                </Button>
              )}
              {this.renderCreateAccountButton(false)}
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    logout: url => dispatch(logout(url)),
    requestAccount: acc => dispatch(requestAccount(acc)),
    revokeRequest: () => dispatch(revokeRequest())
  };
};

const mapStateToProps = state => {
  return {
    plugin: state.app.plugin,
    outside: state.app.outside,
    user: state.auth.user
  };
};

const connected = connect(mapStateToProps, mapDispatchToProps)(User);
export { connected as User, User as TestUser };
